'use client';

import { useLanguage } from '@/contexts/LanguageContext';
import LegalPageShell from '@/components/legal/LegalPageShell';

export default function TermsPage() {
  const { t } = useLanguage();
  const s = t.legal.terms.sections;

  return (
    <LegalPageShell
      title={t.legal.terms.title}
      intro={t.legal.terms.intro}
      sections={[
        s.about,
        s.responsibilities,
        s.subscription,
        s.acceptableUse,
        s.accountSecurity,
        s.availability,
        s.liability,
        s.termination,
        s.changes,
        s.governingLaw,
      ]}
    />
  );
}
